import { flipApi } from 'yxt-biz-pc/packages/api';

// 获取面授列表
export const getFaceList = (params) => {
  return flipApi.post(`/flip/report/list?current=${params.current}&limit=${params.limit}`, params);
};
